import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Input, OnChanges, SimpleChanges, effect, HostListener, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray, CdkDropList, CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SettingsService } from '../../../../../../shared/services/settings/settings.service';
import { ConversationService } from 'src/app/shared/services/conversation/conversation.service';
import { NgIf, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as _ from 'lodash';
import { AppStateService } from 'src/app/shared/services/helpers/app-state.service';


// Define field interface to fix TypeScript errors
interface PageField {
  field_id: any;
  'read-only': boolean;
  label?: string;
  params: any;
  component_type: string;
  type: string;
  question_component_type?: string;
  has_reactor: boolean;
  'visible-if'?: any;
  is_mandatory_if?: any;
  'server-visible-if'?: any;
  allowMultiSelect?: boolean;
  enable_shuffle?: boolean;
  group_id?: string;
  is_wheel_label?: boolean;
}

interface QuestionItem {
  field_id: number;
  interaction_type: string;
  typeIcon: string;
  text: string;
  isPrimary: boolean;
  isPrimaryComment: boolean;
  lastUpdated?: Date;
  expanded?: boolean; // Track expanded state for accordion
  params: any;
  component_type: string;
  label: string;
  type: string;
  question_component_type: string;
  rating_bar_reactor_allowed: boolean;
  hide_label: boolean;
  is_mandatory_if: boolean;
  allowMultiSelect: boolean;
  enable_shuffle: boolean;
}

interface SurveyPage {
  id: number;
  page_title: string;
  type: 'default' | 'thank-you' | 'expired' | 'submitted';
  fields?: any[]; // IDs of questions on this page
  
  // Advanced options
  calculate_for_progress?: boolean;
  isShowProgressBar?: boolean;
  save_on_submit?: boolean;
  enable_auto_scroll?: boolean;
  is_rating_page?: boolean;
  nextButtonText?: string;
  backButtonText?: string; 
  expired_flows?: boolean;
  archive_flows?: boolean;
  is_last_page?: boolean;
  enable_suffle?: boolean;
}

@Component({
    selector: 'app-litmus-intraction-pages',
    templateUrl: './litmus-intraction-pages.component.html',
    styleUrls: ['./litmus-intraction-pages.component.scss'],
    imports: [NgIf, FormsModule, NgFor, CdkDropList, CdkDrag, CdkDragHandle]
})
export class LitmusIntractionPagesComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @ViewChild('pageModal') pageModal!: ElementRef;
  @Input() disableCopy = true; // Added missing property
  @Input() pageconfiguration:any = {};
  // Data properties
  loading = true;
  searchText = '';
  pages: any[] = [];
  filteredPages: any[] = [];
  availableInteractions: any[] = [];
  questions: any[] = [];
  questionsHash: {[key: string]: any} = {};
  configuration: any = null;
  
  // Current page being edited
  currentPage: any = null;
  isEditMode = false;
  buttonLabel: string = 'Save'; // or 'Update' dynamically

  
  // Device selection
  selectedDevice = 'phone';
  devices = ['phone', 'desktop', 'tablet'];
  defaultLanguage = 'english';
  showDeviceDropdown = false;
    
  // Destruction subject
  private destroy$ = new Subject<void>();
  
  // Constants
  private PROJECT_ID = ''; // Should be from a service or route parameter
  public activeTab: 'basic' | 'advance' = 'basic';
  // Pages tab properties
  surveyPages: SurveyPage[] = [];
  // Question list for All Questions tab
  questionsList: QuestionItem[] = [];
  selectedPageIndex: number | null = null;
  selectedPage: SurveyPage | any = null;
  // Page Edit Modal properties
  showPageEditModal = false;
  currentPageQuestions: QuestionItem[] = [];
  availableQuestions: QuestionItem[] = [];
  draggedPageIndex: number | null = null;
  dragTargetIndex: number | null = null;
  questionSearchQuery = '';
  allQuestions: QuestionItem[] = [];
  filteredAllQuestions: QuestionItem[] = [];

  default_rating_button_label = 'Next';
  default_rating_back_button_label = 'Back'

  labelsToMergeWith: any = {}; 
  labelsToMergeFrom: any = {};
        
  
  // Add property to track if save is enabled
  isSaveEnabled = false;
  private lastSavedConfig: any = null;
  private originalConfig: any = null; // Store the truly original configuration
  isUserHasWriteAccess: boolean = false;
  constructor(
    private settingsService: SettingsService,
    private _conversation: ConversationService,
    private _stateService: AppStateService,
    private cdr: ChangeDetectorRef) { 
    effect(() => {
      if (this._stateService.initialized()) {
        const brandDetails: any = this._stateService.brandDetails()
        this.isUserHasWriteAccess = this._conversation.isUserHasWriteAccess('MANAGE_CONVERSATION');
      }
    })
    effect(() => {
      let conversationObject: any = this._conversation.conversationObject();
      if (conversationObject) {
        this.defaultLanguage = this._conversation.default_language;
        if (conversationObject?.brand_detail) {
          this.PROJECT_ID = conversationObject?.brand_detail?._id;
        }
        if (conversationObject?.configuration) {
          this.configuration = conversationObject?.configuration;
          
          // Store the truly original configuration BEFORE any processing
          if (!this.originalConfig) {
            this.originalConfig = Helpers.deepClone(this.configuration);
          }
          
          if(this.lastSavedConfig) {
            this.configuration = Helpers.deepClone(this.lastSavedConfig);
          }
          this.loadConfiguration();
        }
      }
      if(!_.isEmpty(Helpers.brandDetails)) {
        this.disableCopy = _.get(Helpers.brandDetails, "current_configuration.disable_copy");
      }
    })

    // Monitor conversation service's isSaveEnabled property
    effect(() => {
      const conversationIsSaveEnabled = this._conversation.isSaveEnabled;
      
      // If conversation service says there are no unsaved changes, but we have local changes
      if (!conversationIsSaveEnabled && this.isSaveEnabled && this.originalConfig) {
        // Changes were discarded from parent, restore original state
        this.restoreOriginalState();
      }
    })
  }

  ngOnInit(): void {

  }

  ngAfterViewInit(): void {
    // Check if we need to restore state when component becomes visible
    if (!this._conversation.isSaveEnabled && this.originalConfig) {
      this.restoreOriginalState();
    }
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    // if (changes['pageconfiguration']) {
    //   this.configuration = this.pageconfiguration;
    // }
  }

  // Method to ensure component is in correct state when tab becomes active
  onTabActivated(): void {
    // If conversation service indicates no unsaved changes, force restore
    if (!this._conversation.isSaveEnabled && this.originalConfig) {
      this.restoreOriginalState();
    }
  }

  // Method to explicitly restore original state when changes are discarded
  restoreOriginalState(): void {
    if (this.originalConfig) {
      // Force complete reset to truly original state
      this.configuration = Helpers.deepClone(this.originalConfig);
      this.isSaveEnabled = false;
      this._conversation.isSaveEnabled = this.isSaveEnabled;
      
      // Re-extract pages to ensure proper order
      this.extractPagesForDevice();
      this.updateAvailableInteractions();
      
      // Force change detection
      this.cdr.detectChanges();
    }
  }

  // Force complete reinitialization
  forceRefresh(): void {
    if (this.originalConfig) {
      this.configuration = Helpers.deepClone(this.originalConfig);
      this.isSaveEnabled = false;
      this._conversation.isSaveEnabled = this.isSaveEnabled;
      this.loadConfiguration();
    }
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.closePageEditModal();
  }

  // Call this after any config change
  checkConfigChanged(currentPages) {
    this.isSaveEnabled = !_.isEqual(currentPages, this.surveyPages);
    this._conversation.isSaveEnabled = this.isSaveEnabled;
    
    if(!this.isSaveEnabled) {
      this.configuration = Helpers.deepClone(this.originalConfig);
      // Re-extract pages to restore original order
      this.extractPagesForDevice();
      this.updateAvailableInteractions();
    }
  }

  // Load configuration from API
  loadConfiguration() {
    // Extract questions
    this.questions = Array.isArray(this.configuration.fields)? this.configuration.fields.filter(field => field.hasOwnProperty('component_id')):[];

    this.questionsList = [...this.questions]
    // Create a hash for fast lookup
    this.questions.forEach(question => {
      if (question && question.field_id) {
        this.questionsHash[question.field_id] = question;
      }
    });

    // Store the last saved configuration ONLY on first load
    if (!this.lastSavedConfig) {
      this.lastSavedConfig = Helpers.deepClone(this.configuration);
    }
    
    this.isSaveEnabled = false;
    this._conversation.isSaveEnabled = this.isSaveEnabled;
    // Extract pages for the selected device
    this.loading = false;
    this.extractPagesForDevice();
    this.updateAvailableInteractions();

  }
  // Close page edit modal
  closePageEditModal(): void {
    this.showPageEditModal = false;
    this.isEditMode = false;
    this.isSaveEnabled = false;
    this._conversation.isSaveEnabled = this.isSaveEnabled;
    // Reset question lists to default for the selected page
    if (this.selectedPage) {
      const pageFieldIds = new Set((this.selectedPage.fields || []).map(f => f.field_id));
      this.currentPageQuestions = this.questions.filter(q => pageFieldIds.has(q.field_id));
      // Update available interactions to get device-specific filteredAllQuestions
      this.updateAvailableInteractions();
      // Remove questions already in currentPageQuestions from filteredAllQuestions
      this.filteredAllQuestions = this.filteredAllQuestions.filter(q => !pageFieldIds.has(q.field_id));
      // Sort both lists
      this.currentPageQuestions.sort((a, b) => a.text.localeCompare(b.text, undefined, { sensitivity: 'base' }));
    } else {
      this.currentPageQuestions = [];
      // Update available interactions to get device-specific filteredAllQuestions
      this.updateAvailableInteractions();
    }
    // Reset other modal state variables
    this.questionSearchQuery = '';
    this.buttonLabel = 'Save';
    this.selectedPage = null;
    this.selectedPageIndex = null;
  }


  // Move a question to the page
  moveQuestionToPage(question?: QuestionItem): void {
    if (!this.selectedPage) {
      return;
    }
    
    const questionToMove = question || (this.availableQuestions.length > 0 ? this.availableQuestions[0] : null);
    
    if (!questionToMove) {
      return; // No question to move
    }
    
    // Move from available to current
    this.availableQuestions = this.availableQuestions.filter(q => q.field_id !== questionToMove.field_id);
    this.currentPageQuestions.push(questionToMove);
    
    // Enable save since we have questions
    this.isSaveEnabled = true;
    
    // Update the selected page question list
    if (!this.selectedPage.fields) {
      this.selectedPage.fields = [];
    }
    this.selectedPage.fields.push(questionToMove.field_id);
  }

  // Remove a question from the page
  removeQuestionFromPage(question?: QuestionItem): void {
    if (!question) return;
    
    // Remove from currentPageQuestions
    this.currentPageQuestions = this.currentPageQuestions.filter(q => q.field_id !== question.field_id);

    // Add to filteredAllQuestions if not already present
    if (!this.filteredAllQuestions.some(q => q.field_id === question.field_id)) {
      this.filteredAllQuestions.push(question);
      
      // Resort to maintain original order from the main questions array
      const originalQuestionOrder = new Map<number, number>();
      this.questions.forEach((q, index) => {
        originalQuestionOrder.set(q.field_id, index);
      });
      
      this.filteredAllQuestions.sort((a, b) => {
        const posA = originalQuestionOrder.get(a.field_id) ?? Number.MAX_SAFE_INTEGER;
        const posB = originalQuestionOrder.get(b.field_id) ?? Number.MAX_SAFE_INTEGER;
        return posA - posB;
      });
    }
    
    // Disable save if no questions left
    this.isSaveEnabled = this.currentPageQuestions.length > 0;
  }

  // Save changes from the page edit modal
  savePageEdit(): void {

    // Check if there are any questions selected for page
    if (!this.currentPageQuestions || this.currentPageQuestions.length === 0) {
      this.showErrorMessage('Please add at least one question to the page');
      return;
    } 

    let promises:any = [];
    this.currentPageQuestions.forEach(q => {
      promises.push(this.addFieldsToPages(q));
    })

    Promise.all(promises).then((fields) => {
      // this.selectedPage.fields = fields;
      if (this.selectedPage && this.selectedPageIndex == null) {
        // Update the page's questions array to match the new order
        this.selectedPage.fields = fields;//[...this.currentPageQuestions.map(async q => await this.addFieldsToPages(q))];
        this.filteredPages.push(this.selectedPage);
        this.filteredPages.sort((a, b) => a.page_title.localeCompare(b.page_title, undefined, { sensitivity: 'base' }));
      }
  
      if (this.selectedPage && this.selectedPageIndex != null) {
        this.selectedPage.fields = fields;//[...this.currentPageQuestions.map(async q => await this.addFieldsToPages(q))];
      }
  
      const pageId = this.selectedPage.id;
      // Find the index in the original array
      const realIndex = this.surveyPages.findIndex(p => p.id === pageId);
      if (realIndex >= 0) {
        // Update the page in the original array
        this.surveyPages[realIndex] = { ...this.selectedPage };
        
        // Update the filtered array if it exists in there
        const filteredIndex = this.filteredPages.findIndex(p => p.id === pageId);
        if (filteredIndex >= 0) {
          this.filteredPages[filteredIndex] = { ...this.selectedPage };
        }
      }
      this.currentPage = { ...this.selectedPage };
      // Add to configuration if it's a new page
      if (!this.isEditMode) {
        this.addPageToConfiguration();
      }else {
        // Add page to screens
        this.configuration.screens[this.selectedDevice][this.defaultLanguage] = this.filteredPages;
        this.configuration.languages[this.configuration.default_language].labels = this.labelsToMergeWith;
        // this.configuration.flows[this.selectedDevice][this.defaultLanguage] = [];
      }
      // Save the configuration
      this.saveConfiguration(false, this.isEditMode ? 'Page updated' : 'Page created');
      this.lastSavedConfig = Helpers.deepClone(this.configuration);
      this.isSaveEnabled = false;
      this._conversation.isSaveEnabled = this.isSaveEnabled;
      this.closePageEditModal();
    })
    
  }

  // Save conversation
  saveConversation() {
    if (!this.isSaveEnabled) return;
    this.saveConfiguration(false, 'Configuration Saved');
    this.lastSavedConfig = Helpers.deepClone(this.configuration);
    this.isSaveEnabled = false;
    this._conversation.isSaveEnabled = this.isSaveEnabled;
  }
  // Start drag on mouse down
  startDrag(index: number, event: MouseEvent): void {
    // Prevent default to avoid text selection
    event.preventDefault();
    
    // Simplified approach that avoids creating synthetic DragEvent objects
    const listItem = (event.target as HTMLElement).closest('.page-list-item');
    if (listItem) {
      listItem.setAttribute('draggable', 'true');
      // The native dragstart event will be triggered naturally
    }
  }

  // Handle dragstart event
  onDragStart(index: number, event: DragEvent): void {
    this.draggedPageIndex = index;
    
    // Set data for drag operation
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', index.toString());
      
      // Simplified approach that doesn't try to create custom ghost elements
      const target = event.target as HTMLElement;
      target.classList.add('dragging');
    }
  }

  // Handle dragover event
  onDragOver(event: DragEvent): void {
    // Prevent default to allow drop
    event.preventDefault();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
  }

  // Handle dragenter event
  onDragEnter(index: number, event: DragEvent): void {
    // Prevent default
    event.preventDefault();
    
    // Update target index if different from dragged item
    if (index !== this.draggedPageIndex) {
      this.dragTargetIndex = index;
    } else {
      this.dragTargetIndex = null;
    }
  }

  // Handle dragleave event
  onDragLeave(event: DragEvent): void {
    // Only clear if leaving outside the list
    const target = event.target as HTMLElement;
    const relatedTarget = event.relatedTarget as HTMLElement;
    
    if (relatedTarget && !target.contains(relatedTarget) && !target.closest('.pages-list')?.contains(relatedTarget)) {
      this.dragTargetIndex = null;
    }
  }

  // Handle dragend event
  onDragEnd(): void {
    // Reset drag state
    this.draggedPageIndex = null;
    this.dragTargetIndex = null;
  }

  /**
 * Toggle selection of all questions
 */
  toggleAllQuestions(type?): void {
    if(!this.isUserHasWriteAccess) {
      Helpers.smallAlertBox('Access Denied', 'You do not have write permission to add or remove questions. Only read access is available.', 'warning', 4000);
      return;
    }
    if (type == 'Remove all') {
      // Deselect all: move all from currentPageQuestions to filteredAllQuestions
      this.filteredAllQuestions = [...this.filteredAllQuestions, ...this.currentPageQuestions];
      
      // Resort to maintain original order from the main questions array
      const originalQuestionOrder = new Map<number, number>();
      this.questions.forEach((question, index) => {
        originalQuestionOrder.set(question.field_id, index);
      });
      
      this.filteredAllQuestions.sort((a, b) => {
        const posA = originalQuestionOrder.get(a.field_id) ?? Number.MAX_SAFE_INTEGER;
        const posB = originalQuestionOrder.get(b.field_id) ?? Number.MAX_SAFE_INTEGER;
        return posA - posB;
      });
      
      this.currentPageQuestions = [];
    } else {
      // Select all: move all from filteredAllQuestions to currentPageQuestions
      this.currentPageQuestions = [...this.currentPageQuestions, ...this.filteredAllQuestions];
      this.filteredAllQuestions = [];
    }
    // Set initial save state
    this.isSaveEnabled = this.currentPageQuestions.length > 0;
  }
    /**
 * Check if all questions are selected
 */
  areAllQuestionsSelected(type?): boolean {
    // True if all questions in filteredAllQuestions are in currentPageQuestions (i.e., filteredAllQuestions is empty)
    if (type == 'Add all') {
      return this.filteredAllQuestions.length > 0;
    } else if(type == 'Remove all') {
      return this.currentPageQuestions.length > 0;
    } else {
      return this.filteredAllQuestions.length === 0 && this.currentPageQuestions.length > 0;
    }
  }
  /**
   * Check if a question is selected for the current page
   */
  isQuestionSelected(question: QuestionItem): boolean {
    return this.currentPageQuestions.some(q => q.field_id === question.field_id);
  }

  /**
 * Toggle question selection
 */
  toggleQuestionSelection(question: QuestionItem): void {
    if (this.isQuestionSelected(question)) {
      // Deselect: remove from currentPageQuestions and add back to filteredAllQuestions
      this.currentPageQuestions = this.currentPageQuestions.filter(q => q.field_id !== question.field_id);
      
      // Add back to filteredAllQuestions and resort to maintain original order
      if (!this.filteredAllQuestions.some(q => q.field_id === question.field_id)) {
        this.filteredAllQuestions.push(question);
        
        // Resort to maintain original order from the main questions array
        const originalQuestionOrder = new Map<number, number>();
        this.questions.forEach((q, index) => {
          originalQuestionOrder.set(q.field_id, index);
        });
        
        this.filteredAllQuestions.sort((a, b) => {
          const posA = originalQuestionOrder.get(a.field_id) ?? Number.MAX_SAFE_INTEGER;
          const posB = originalQuestionOrder.get(b.field_id) ?? Number.MAX_SAFE_INTEGER;
          return posA - posB;
        });
      }
    } else {
      // Select: remove from filteredAllQuestions and add to currentPageQuestions
      this.filteredAllQuestions = this.filteredAllQuestions.filter(q => q.field_id !== question.field_id);
      if (!this.currentPageQuestions.some(q => q.field_id === question.field_id)) {
        this.currentPageQuestions.push(question);
      }
    }
    // Set initial save state
    this.isSaveEnabled = this.currentPageQuestions.length > 0;
  }
  /**
   * Handle dropping a question when reordering
   */
  dropQuestion(event: CdkDragDrop<QuestionItem[]>): void {
    // if (!this.selectedPage || !this.selectedPage.fields) return;
    
    // Move the item in the array
    moveItemInArray(this.currentPageQuestions, event.previousIndex, event.currentIndex);
    // Update the page's questions array to match the new order
    // const promises:any = [];
    // this.currentPageQuestions.forEach(q => {
    //   promises.push(this.addFieldsToPages(q));
    // })
    // Promise.all(promises).then((fields) => {  
    //   this.selectedPage.fields = fields;
    // })

  }
   addFieldsToPages(question) {
    return new Promise((resolve, reject) => {
      this._conversation.getParamsForMQL(question.params).then((params) => {
        const field: PageField = {
          field_id: question.field_id,
          'read-only': question['read-only'],
          label: question.label,
          params: params || {}, 
          component_type: question.component_type,
          type: question.type,
          question_component_type: question.question_component_type,
          has_reactor: question.rating_bar_reactor_allowed
        };
        
        // Add conditional properties
        if (question.hide_label === true) {
          delete field.label;
        }
        
        if (question.question_component_type) {
          field.question_component_type = question.question_component_type;
        }
        
        if (question['visible-if']) {
          field['visible-if'] = question['visible-if'];
        }
        
        if (question.is_mandatory_if) {
          field.is_mandatory_if = question.is_mandatory_if;
        }
        
        if (question['server-visible-if']) {
          field['server-visible-if'] = question['server-visible-if'];
        }
        
        if (question.allowMultiSelect !== undefined) {
          field.allowMultiSelect = question.allowMultiSelect;
          field.enable_shuffle = (question.allowMultiSelect && question.enable_shuffle) ? true : false;
        }
        resolve(field);
      })

    })
    // Create field object for the page

  }
  // Handle Thank You page toggle
  onThankYouPageChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement)?.checked || false;
    
    // Check if another thank you page already exists
    const existingThankYouPage = this.filteredPages.find(page => 
      page.id !== this.selectedPage?.id && page.is_last_page
    );
    
    if (isChecked && existingThankYouPage) {
      this.showErrorMessage('A Thank You page already exists. Only one Thank You page is allowed.');
      (event.target as HTMLInputElement).checked = false;
      return;
    }
    
    this.toggleThankYouPage(isChecked);
  }
  
  // Toggle Thank You page
  toggleThankYouPage(isEnabled: boolean): void {
    if (!this.selectedPage) return;
    
    if (isEnabled) {
      // Set this page as a Thank You page
      this.selectedPage.type = 'thank-you';
      this.selectedPage.is_last_page = true;
      this.selectedPage.expired_flows = false;
      this.selectedPage.archive_flows = false;
      this.selectedPage.calculate_for_progress = false;
      this.selectedPage.isShowProgressBar = false;
      this.selectedPage.is_rating_page = false;
    } else {
      // Reset to default page
      this.selectedPage.type = 'default';
      this.selectedPage.is_last_page = false;
    }
  }
  // Handle Link Expired checkbox change event
  onLinkExpiredChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement)?.checked || false;
    
    // Check if another expired page already exists
    const existingExpiredPage = this.filteredPages.find(page => 
      page.id !== this.selectedPage?.id && page.expired_flows
    );
    
    if (isChecked && existingExpiredPage) {
      this.showErrorMessage('A Link Expired page already exists. Only one Link Expired page is allowed.');
      (event.target as HTMLInputElement).checked = false;
      return;
    }
    
    this.toggleLinkExpiredPage(isChecked);
  }
  // Handle Link Expired page toggle
  toggleLinkExpiredPage(isEnabled: boolean): void {
    if (!this.selectedPage) return;
    
    if (isEnabled) {
      // Set this page as a Link Expired page
      this.selectedPage.type = 'expired';
      this.selectedPage.expired_flows = true;
      this.selectedPage.archive_flows = false;
      this.selectedPage.is_last_page = false;
      this.selectedPage.calculate_for_progress = false;
      this.selectedPage.isShowProgressBar = false;
      this.selectedPage.save_on_submit = false;
      this.selectedPage.is_rating_page = false;
      this.selectedPage.enable_suffle = false;
    } else {
      // Reset to default page
      this.selectedPage.type = 'default';
      this.selectedPage.expired_flows = false;
      this.selectedPage.enable_suffle = true;
    }
  }
  // Handle Response Submitted checkbox change event
  onResponseSubmittedChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement)?.checked || false;
    
    // Check if another submitted page already exists
    const existingSubmittedPage = this.filteredPages.find(page => 
      page.id !== this.selectedPage?.id && page.archive_flows
    );
    
    if (isChecked && existingSubmittedPage) {
      this.showErrorMessage('A Response Already Submitted page already exists. Only one Response Already Submitted page is allowed.');
      (event.target as HTMLInputElement).checked = false;
      return;
    }
    
    this.toggleResponseSubmittedPage(isChecked);
  }
  // Handle Response Already Submitted page toggle
  toggleResponseSubmittedPage(isEnabled: boolean): void {
    if (!this.selectedPage) return;
    
    if (isEnabled) {
      // Set this page as a Response Already Submitted page
      this.selectedPage.type = 'submitted';
      this.selectedPage.archive_flows = true;
      this.selectedPage.expired_flows = false;
      this.selectedPage.is_last_page = false;
      this.selectedPage.calculate_for_progress = false;
      this.selectedPage.isShowProgressBar = false;
      this.selectedPage.save_on_submit = false;
      this.selectedPage.is_rating_page = false;
      this.selectedPage.enable_suffle = false;
    } else {
      // Reset to default page
      this.selectedPage.type = 'default';
      this.selectedPage.archive_flows = false;
      this.selectedPage.enable_suffle = true;
    }
  }

  // Mapping
  labelsMapperText(key) {
    return this.labelsToMergeWith[key];
  }
  // Select a page for editing
  selectPage(index: any) {
    this.selectedPageIndex = index;
    this.selectedPage = { ...this.filteredPages[index] }; // Make a copy to edit
    // Assign label text in readable text
    this.default_rating_button_label = this.labelsMapperText(this.selectedPage?.rating_button_label);
    this.default_rating_back_button_label = this.labelsMapperText(this.selectedPage?.rating_back_button_label);
  }
  // Extract pages for the selected device
  extractPagesForDevice(): void {
    if (!this.configuration) {
      this.handleError('Cannot extract pages: Configuration is null or undefined');
      return;
    }
    
    this.pages = [];
    
    try {
      // Check if screens and flows exist
      if (this.configuration.screens && 
          this.configuration.screens[this.selectedDevice] && 
          this.configuration.screens[this.selectedDevice][this.defaultLanguage]) {
        
        const deviceScreens = this.configuration.screens[this.selectedDevice][this.defaultLanguage];

        // labelsToMergeWith will contains defaultConversation labels
        this.labelsToMergeWith = this.configuration.languages[this.configuration.default_language].labels;

        if (!Array.isArray(deviceScreens)) {
          this.handleError(`Device screens for ${this.selectedDevice} is not an array`);
          return;
        }
        
        // Get the flow order
        const flowOrder = this.configuration.flows?.[this.selectedDevice]?.[this.defaultLanguage] || [];
        
        // Map pages with their order
        deviceScreens.forEach((page: any) => {
          if (page && page.id) {
            const currentIndex = flowOrder.indexOf(page.id);
            // Map fields to full question objects from this.questionsList
            let mappedFields = [];
            if (Array.isArray(page.fields)) {
              mappedFields = page.fields
                .map((field: any) => this.questionsList.find(q => q.field_id === (field.field_id || field)))
                .filter(q => q !== undefined);
            }
            this.pages.push({
              ...page,
              fields: mappedFields,
              currentIndex: currentIndex !== -1 ? currentIndex : Number.MAX_SAFE_INTEGER
            });
          }
        });
        
        // Sort pages by their index in the flow
        this.pages.sort((a, b) => a.currentIndex - b.currentIndex);
      } else {
        // No configuration found for this device, create empty structure
        if (!this.configuration.screens) {
          this.configuration.screens = {};
        }
        
        if (!this.configuration.screens[this.selectedDevice]) {
          this.configuration.screens[this.selectedDevice] = {};
        }
        
        if (!this.configuration.screens[this.selectedDevice][this.defaultLanguage]) {
          this.configuration.screens[this.selectedDevice][this.defaultLanguage] = [];
        }
        
        if (!this.configuration.flows) {
          this.configuration.flows = {};
        }
        
        if (!this.configuration.flows[this.selectedDevice]) {
          this.configuration.flows[this.selectedDevice] = {};
        }
        
        if (!this.configuration.flows[this.selectedDevice][this.defaultLanguage]) {
          this.configuration.flows[this.selectedDevice][this.defaultLanguage] = [];
        }
      }
      this.filterPages();
      
    } catch (error) {
      this.handleError('Error extracting pages for device', error);
    }
  }
  
  // Filter pages based on search text
  filterPages(): void {
    if (!this.searchText || this.searchText.trim() === '') {
      this.filteredPages = [...this.pages];
      // Sort pages by currentIndex
      this.filteredPages.sort((a, b) => a.currentIndex - b.currentIndex);
    } else {
      const searchTerm = this.searchText.toLowerCase().trim();
      this.filteredPages = this.pages.filter(p => {
        return p.page_title.toLowerCase().includes(searchTerm);
      });
      // Sort filtered pages by currentIndex
      this.filteredPages.sort((a, b) => a.currentIndex - b.currentIndex);
    }
    this.surveyPages = [...this.filteredPages];
  }
  
  // Set default device
  setDefaultDevice(device: string): void {
    this.selectedDevice = device;
    // Reload pages for the selected device
    this.extractPagesForDevice();
    // Update available interactions for the new device
    this.updateAvailableInteractions();
  }

  // Toggle device dropdown
  toggleDeviceDropdown(): void {
    this.showDeviceDropdown = !this.showDeviceDropdown;
  }

  // Select device from dropdown
  selectDevice(device: string): void {
    if (!this.guardUnsavedChanges(() => this._actuallySelectDevice(device))) {
      return;
    }
    this._actuallySelectDevice(device);
  }

  private _actuallySelectDevice(device: string): void {
    // this.isSaveEnabled = false;
    this.selectedDevice = device;
    this.showDeviceDropdown = false;
    this.extractPagesForDevice();
    this.updateAvailableInteractions();
  }

  // Close dropdown when clicking outside
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.device-selector-container')) {
      this.showDeviceDropdown = false;
    }
  }
  
  // Reusable guard for unsaved changes
  private guardUnsavedChanges(onContinue: () => void): boolean {
    if (this.isSaveEnabled) {
      Helpers.SmartMessageBox({
        title: "You have reordered the rows.",
        content: "To save your changes, please use the <b>Save</b> button at the top right of the page. Click Discard Changes to lose your edits and continue. Click Cancel to close this popup and keep editing.",
        buttons: [
          { text: "Cancel", type: "secondary", key: "Cancel" },
          { text: "Discard Changes", type: "primary", key: "Discard" }
        ]
      }, (ButtonPressed) => {
        setTimeout(() => {
          if (ButtonPressed === "Discard") {
            // Restore configuration and UI to last saved state
            this.configuration = Helpers.deepClone(this.lastSavedConfig);
            this.extractPagesForDevice();
            this.isSaveEnabled = false;
            this._conversation.isSaveEnabled = this.isSaveEnabled;
            onContinue();
          }
          // If Cancel, do nothing
        }, 50);
      });
      return false;
    }
    return true;
  }

  // Guarded openPageModal
  openPageModal(template: any, pageId?: string, index?: number): void {
    if (!this.guardUnsavedChanges(() => this._actuallyOpenPageModal(template, pageId, index))) {
      return;
    }
    this._actuallyOpenPageModal(template, pageId, index);
  }
  private _actuallyOpenPageModal(template: any, pageId?: string, index?: number): void {
    this.isEditMode = !!pageId;
    this.showPageEditModal = true;

    if(this.isEditMode) {
      this.buttonLabel = 'Update';
      this.selectPage(index)
      // Initialize question lists
      if (this.selectedPage && this.selectedPage.fields) {
        this.currentPageQuestions = this.selectedPage.fields
          .map(field => this.questionsList.find(q => q.field_id === field.field_id))
          .filter(q => q !== undefined) as QuestionItem[];
        
        this.availableQuestions = this.questionsList.filter(q => 
          !this.selectedPage?.fields?.includes(q.field_id)
        );
      } else {
        this.currentPageQuestions = [];
        this.availableQuestions = [...this.questionsList];
      }
    } else {
      // For new pages, initialize with questions not used in current device
      this.updateAvailableInteractions(); // This will set filteredAllQuestions correctly
      this.filteredAllQuestions = [...this.filteredAllQuestions]; // Copy the device-specific list
      this.currentPageQuestions = [];
      this.selectedPage = this.initNewPage();
    }
    // For new simplified UI
    this.allQuestions = [...this.questionsList];
    this.questionSearchQuery = '';
    
    // Set initial save state
    this.isSaveEnabled = this.currentPageQuestions.length > 0;
  }

  // Calls your method with that value to generate Label
  onRatingButtonLabelChange(event) {
    this.default_rating_back_button_label = event.target.value;
    this.selectedPage.rating_button_label = this.generateDefaultButtonLabel(event.target.value);
  }

  onRatingBackButtonLabelChange(event) {
    this.default_rating_button_label = event.target.value;
    this.selectedPage.rating_back_button_label = this.generateDefaultButtonLabel(event.target.value);
  }
  
  // Get page by ID
  getPageById(pageId: string): any {
    return this.pages.find(page => page.id === pageId);
  }
  
  // Initialize a new page
  initNewPage(): any {
    const deviceId = this.selectedDevice;
    // const pageId = `${deviceId}_page_${this.generateRandomId()}`;
    
    // Find the next page number
    const nextPageNumber = this.getNextPageNumber();
    let pageTitle = '';
    let pageId = '';
    if (this.disableCopy) {
      pageId = `page_${this.generateRandomId()}`;
      pageTitle = `Page-${nextPageNumber}`;
    } else {
      pageId = `${deviceId}_page_${this.generateRandomId()}`;
      pageTitle = `Page-${nextPageNumber}-${this.capitalizeFirstLetter(deviceId)}`;
    }
    var indexBeforeLabel: any;
    // Create new page object
    const newPage = {
      id: pageId,
      page_title: pageTitle,
      fields: [],
      is_rating_page: true,
      save_on_submit: true,
      enable_auto_scroll: true,
      disable_auto_scroll: false,
      rating_button_label: this.generateDefaultButtonLabel('Next'),
      rating_back_button_label: this.generateDefaultButtonLabel('Back'),
      calculate_for_progress: true,
      isShowProgressBar: true,
      currentIndex: this.pages.length,
      is_last_page: false,
      expired_flows: false,
      archive_flows: false
    };

    return newPage;
  }
  
  // Get the next page number
  getNextPageNumber(): number {
    const pageNumbers = this.pages
      .map(page => {
        const matches = page.page_title.match(/\d+/g);
        return matches ? parseInt(matches[0], 10) : 0;
      })
      .filter(num => !isNaN(num));
    
    return pageNumbers.length > 0 ? Math.max(...pageNumbers) + 1 : 1;
  }
  
  // Copy display configuration to another device
  copyDisplayConfiguration(fromDevice: string, toDevice: string): void {
    if (!this.guardUnsavedChanges(() => this._actuallyCopyDisplayConfiguration(fromDevice, toDevice))) {
      return;
    }
    this._actuallyCopyDisplayConfiguration(fromDevice, toDevice);
  }
  private _actuallyCopyDisplayConfiguration(fromDevice: string, toDevice: string): void {
    if (!this.configuration || !this.configuration.screens) return;

    var errorMsg = `Are you sure you want to copy the pages from "${fromDevice}" to "${toDevice}"?`;
    var title = "Copy Page";
    var buttons = [{
      text: "No",
      type: 'secondary',
      key: 'No'
    }, {
      text: "Yes",
      type: 'primary',
      key: 'Yes'
    }];

    Helpers.SmartMessageBox({
      title: title,
      content: errorMsg,
      buttons: buttons
    }, (ButtonPressed) => {
        setTimeout(() => {
          if (ButtonPressed === "Yes") {
            const sourceScreens = this.configuration.screens[fromDevice];
            const sourceFlows = this.configuration.flows?.[fromDevice];
            
            if (!sourceScreens || !sourceFlows) {
              this.handleError(`No configuration found for ${fromDevice}`);
              return;
            }
            
            // Create deep copies
            const copiedScreens = JSON.parse(JSON.stringify(sourceScreens));
            const copiedFlows = JSON.parse(JSON.stringify(sourceFlows));
            
            // Update page IDs and titles in the copied screens
            if (copiedScreens[this.defaultLanguage]) {
              copiedScreens[this.defaultLanguage] = copiedScreens[this.defaultLanguage].map((page: any) => {
                // Update page ID
                if (page.id) {
                  page.id = page.id.replace(fromDevice, toDevice);
                }
                
                // Update page title
                if (page.page_title) {
                  page.page_title = page.page_title.replace(
                    new RegExp(`-${this.capitalizeFirstLetter(fromDevice)}`, 'i'),
                    `-${this.capitalizeFirstLetter(toDevice)}`
                  );
                }
                
                return page;
              });
            }
            // Update flows page ID
            if (copiedFlows[this.defaultLanguage]) {
              copiedFlows[this.defaultLanguage] = copiedFlows[this.defaultLanguage].map((id: any) => {
                if(id) {
                  return id.replace(fromDevice, toDevice);
                }
              })
            }
            
            // Update the configuration with modified copies
            this.configuration.screens[toDevice] = copiedScreens;
            this.configuration.flows[toDevice] = copiedFlows;
            
            // Update the display to show the copied device
            this.selectedDevice = toDevice;
            this.extractPagesForDevice();
            
            // Save the changes
            this.saveConfiguration(false, `Configuration copied from ${fromDevice} to ${toDevice}`);
          }
        }, 50);
    });
  }
  
  // Save configuration to API
  saveConfiguration(isPublish: boolean = false, message: string = 'Configuration saved'): void {
    this.loading = true;

    this._conversation.configuration = Helpers.deepClone(this.configuration);
    this._conversation.saveConversation(false, message).then((result) => {
      this.loading = false;
      // Update lastSavedConfig after successful save
      this.lastSavedConfig = Helpers.deepClone(this.configuration);
    }).catch((error) => {
        this.loading = false;
    })
  }
  
  // Get all field IDs currently assigned to pages
  getAllFieldIdsOnPages(): string[] {
    const fieldIds: string[] = [];
    
    if (this.configuration && this.configuration.screens) {
      const deviceScreens = this.configuration.screens[this.selectedDevice];
      
      if (deviceScreens && deviceScreens[this.defaultLanguage]) {
        deviceScreens[this.defaultLanguage].forEach((page: any) => {
          if (page.fields && Array.isArray(page.fields)) {
            page.fields.forEach((field: any) => {
              if (field.field_id && this.currentPage.id !== page.id) {
                fieldIds.push(field.field_id);
              }
            });
          }
        });
      }
    }
    
    return fieldIds;
  }
  
  // Handle drag and drop reordering of pages
  dropPage(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex !== event.currentIndex) {
      // Create a new array to avoid in-place mutation
      const newPages = [...this.filteredPages];
      moveItemInArray(newPages, event.previousIndex, event.currentIndex);
      this.filteredPages = newPages;
      this.updateFlowOrder();
      this.checkConfigChanged(this.filteredPages);
    }
  }
  
  // Update the flow order after reordering pages
  updateFlowOrder(): void {
    if (!this.configuration || !this.configuration.flows) return;
    
    // Update currentIndex
    this.filteredPages.forEach((page, index) => {
      page.currentIndex = index;
    });
    
    // Update the flow in the configuration
    if (!this.configuration.flows[this.selectedDevice]) {
      this.configuration.flows[this.selectedDevice] = {};
    }
    
    if (!this.configuration.flows[this.selectedDevice][this.defaultLanguage]) {
      this.configuration.flows[this.selectedDevice][this.defaultLanguage] = [];
    }
    
    // Set the flow order based on the current page order
    this.configuration.flows[this.selectedDevice][this.defaultLanguage] = 
      this.filteredPages.map(page => page.id);

    // Update the flow in the configuration
    if (!this.configuration.screens[this.selectedDevice]) {
      this.configuration.screens[this.selectedDevice] = {};
    }

    if (!this.configuration.screens[this.selectedDevice][this.defaultLanguage]) {
      this.configuration.screens[this.selectedDevice][this.defaultLanguage] = [];
    }

    this.configuration.screens[this.selectedDevice][this.defaultLanguage] = this.filteredPages;
  }
  
  // Add a new page to the configuration
  addPageToConfiguration(): void {
    if (!this.configuration || !this.currentPage) return;
    
    // Check if page already exists to prevent duplicates
    const existingPage = this.configuration.screens[this.selectedDevice]?.[this.defaultLanguage]?.find(
      (page: any) => page.id === this.currentPage.id
    );
    
    if (existingPage) {
      console.warn('Page already exists, skipping duplicate creation:', this.currentPage.id);
      return;
    }
    
    // Ensure screens and flows exist
    if (!this.configuration.screens) {
      this.configuration.screens = {};
    }
    
    if (!this.configuration.screens[this.selectedDevice]) {
      this.configuration.screens[this.selectedDevice] = {};
    }
    
    if (!this.configuration.screens[this.selectedDevice][this.defaultLanguage]) {
      this.configuration.screens[this.selectedDevice][this.defaultLanguage] = [];
    }
    
    if (!this.configuration.flows) {
      this.configuration.flows = {};
    }
    
    if (!this.configuration.flows[this.selectedDevice]) {
      this.configuration.flows[this.selectedDevice] = {};
    }
    
    if (!this.configuration.flows[this.selectedDevice][this.defaultLanguage]) {
      this.configuration.flows[this.selectedDevice][this.defaultLanguage] = [];
    }
    
    // Add page to screens
    this.configuration.screens[this.selectedDevice][this.defaultLanguage].push(this.currentPage);
    
    // Add page to flow - insert at the correct position
    let insertIndex = this.configuration.flows[this.selectedDevice][this.defaultLanguage].length;
    
    // Find the first non-rating page to insert before it
    for (let i = 0; i < this.configuration.flows[this.selectedDevice][this.defaultLanguage].length; i++) {
      const pageObj = this.getPageById(this.configuration.flows[this.selectedDevice][this.defaultLanguage][i]);
      if (pageObj && pageObj.is_rating_page === false) {
        insertIndex = i;
        break;
      }
    }
    
    this.configuration.flows[this.selectedDevice][this.defaultLanguage].splice(insertIndex, 0, this.currentPage.id);

    // Add labels
    if(!this.configuration.languages[this.configuration.default_language].labels) {
      this.configuration.languages[this.configuration.default_language].labels = {};
    }
    this.configuration.languages[this.configuration.default_language].labels = this.labelsToMergeWith;
    
    // Add to local pages array
    this.pages.push(this.currentPage);
    
    // Update filtered pages
    this.filterPages();
    this.updateAvailableInteractions();
  }
  
  // Handle special page types (thank you, expired, already submitted)
  handleSpecialPageTypes(): void {
    if (!this.configuration || !this.currentPage) return;
    
    // Get all pages
    const allPages = this.configuration.screens?.[this.selectedDevice]?.[this.defaultLanguage] || [];
    
    // Update special page flags
    if (this.currentPage.is_last_page || this.currentPage.expired_flows || this.currentPage.archive_flows) {
      // Only one page can be each special type
      allPages.forEach((page: any) => {
        if (page.id !== this.currentPage.id) {
          if (this.currentPage.is_last_page && page.is_last_page) {
            page.is_last_page = false;
          }
          
          if (this.currentPage.expired_flows && page.expired_flows) {
            page.expired_flows = false;
          }
          
          if (this.currentPage.archive_flows && page.archive_flows) {
            page.archive_flows = false;
          }
        }
      });
      
      // Special pages can't be in progress calculation
      if (this.currentPage.is_last_page || this.currentPage.expired_flows || this.currentPage.archive_flows) {
        this.currentPage.calculate_for_progress = false;
        this.currentPage.isShowProgressBar = false;
      }
    }
  }
  
  // Delete a page
  deletePage(page: any): void {
    if (!this.guardUnsavedChanges(() => this._actuallyDeletePage(page))) {
      return;
    }
    this._actuallyDeletePage(page);
  }
  private _actuallyDeletePage(page: any): void {
    if (!this.configuration || !page) return;
    
    var errorMsg = `Are you sure you want to delete the page "${page.page_title}"?`;
    var title = "Delete Page";
    var buttons = [{
      text: "No",
      type: 'secondary',
      key: 'No'
    }, {
      text: "Yes",
      type: 'danger',
      key: 'Yes'
    }];

    Helpers.SmartMessageBox({
      title: title,
      content: errorMsg,
      buttons: buttons
    }, (ButtonPressed) => {
      setTimeout(() => {
        if (ButtonPressed === "Yes") {
          // Remove from screens
          if (this.configuration.screens?.[this.selectedDevice]?.[this.defaultLanguage]) {
            this.configuration.screens[this.selectedDevice][this.defaultLanguage] = 
              this.configuration.screens[this.selectedDevice][this.defaultLanguage].filter(
                (p: any) => p.id !== page.id
              );
          }
        
          // Remove from flows
          if (this.configuration.flows?.[this.selectedDevice]?.[this.defaultLanguage]) {
            this.configuration.flows[this.selectedDevice][this.defaultLanguage] = 
              this.configuration.flows[this.selectedDevice][this.defaultLanguage].filter(
                (id: string) => id !== page.id
              );
          }
        
          // Remove from local array
          this.pages = this.pages.filter(p => p.id !== page.id);
          
          // Update filtered pages and survey pages
          this.filterPages();
          this.surveyPages = [...this.filteredPages];
          this.updateAvailableInteractions();
          
          // Force change detection to update UI
          this.cdr.detectChanges();
          
          // Save the changes
          this.saveConfiguration(false, `Page "${page.page_title}" deleted`);
        }
      }, 50);
    });

  }
  
  // Utility functions
  
  // Generate a random ID
  generateRandomId(): any {
    return Math.floor(Math.random() * 1e13)
  }

  // check if text is already exist (if exist - we replace text only: to avoid redundant labelIds)
  getPropertyNameForText(allLabels, text) {
    var properyFound: any = null;
    for (var propName in allLabels) {
        var propValue = allLabels[propName];
        if (propValue == text) {
            properyFound = propName;
            break;
        }
    }
    return properyFound;
  }
  // Set new Labels 
  setLabelById(labelId, text) {
    this.labelsToMergeWith[labelId.toString()] = text;
  }
  generateId(type) {
    return (type.toString() + "_" + (new Date()).getTime()).toString();
  }
  // Generate default button label
  generateDefaultButtonLabel(text): string {
    let buttonText = text, buttonLabelId: any = null, existingLabelForText = (this.getPropertyNameForText(this.labelsToMergeWith, buttonText));
    if (!existingLabelForText) {
      buttonLabelId = this.generateId('label') + Helpers.getRandomString();
      this.setLabelById(buttonLabelId, buttonText);
    } else {
        buttonLabelId = existingLabelForText;
    }    
    return buttonLabelId;
  }
  
  // Check if a component is a reactor
  isReactorComponent(componentType: string): boolean {
    if (!componentType) return false;
    
    return componentType.includes('reactor');
  }
  
  // Capitalize first letter
  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  
  // Show error message
  showErrorMessage(message: string): void {
    Helpers.smallAlertBox("Error", message, "error", 2000);
  }
  
  // Handle error
  handleError(message: string, error?: any): void {
    console.error(message, error);
    // In a real app, you would use a toast or notification service
  }
  
  // For template usage - format text
  capitalize(text: string): string {
    return text.charAt(0).toUpperCase() + text.slice(1);
  }
  
  // Helper method to check if a question is already on the current page
  isQuestionOnPage(fieldId: string): boolean {
    if (!this.currentPage || !this.currentPage.fields || !this.currentPage.fields.length) {
      return false;
    }
    
    return this.currentPage.fields.some((field: any) => field.field_id === fieldId);
  }

  // Utility: Update availableInteractions automatically
  updateAvailableInteractions() {
    // Get all field IDs used across ALL devices, not just the current device
    const usedFieldIds = new Set<string>();
    
    // Iterate through all devices to get used field IDs
    this.devices.forEach(device => {
      const deviceScreens = this.configuration?.screens?.[device]?.[this.defaultLanguage] || [];
      deviceScreens.forEach((page: any) => {
        if (page.fields && Array.isArray(page.fields)) {
          page.fields.forEach((field: any) => {
            if (field.field_id) {
              usedFieldIds.add(field.field_id);
            }
          });
        }
      });
    });
    
    // Filter questions that are not used in any device
    this.availableInteractions = this.questions.filter(
      question => !usedFieldIds.has(question.field_id)
    );
    
    // For filteredAllQuestions, we need to consider the current device context
    // Get field IDs used in the current device only
    const currentDeviceUsedFieldIds = new Set<string>();
    const currentDeviceScreens = this.configuration?.screens?.[this.selectedDevice]?.[this.defaultLanguage] || [];
    currentDeviceScreens.forEach((page: any) => {
      if (page.fields && Array.isArray(page.fields)) {
        page.fields.forEach((field: any) => {
          if (field.field_id) {
            currentDeviceUsedFieldIds.add(field.field_id);
          }
        });
      }
    });
    
    // filteredAllQuestions should show questions not used in the current device
    const newFilteredAllQuestions = this.questions.filter(
      question => !currentDeviceUsedFieldIds.has(question.field_id)
    );
    
    // Sort by the original order in the main questions array to maintain consistent ordering
    const originalQuestionOrder = new Map<number, number>();
    this.questions.forEach((question, index) => {
      originalQuestionOrder.set(question.field_id, index);
    });
    
    newFilteredAllQuestions.sort((a, b) => {
      const posA = originalQuestionOrder.get(a.field_id) ?? Number.MAX_SAFE_INTEGER;
      const posB = originalQuestionOrder.get(b.field_id) ?? Number.MAX_SAFE_INTEGER;
      return posA - posB;
    });
    
    this.filteredAllQuestions = newFilteredAllQuestions;
  }
}
